import loadable from '@loadable/component';

const PrivacyLoadable = loadable(() => import(/* webpackChunkName: 'privacy' */ './Privacy'));

const Privacy = () => <PrivacyLoadable />;

export default Privacy;
